import * as React from "react";

import { Client, Role } from "../../../../../domain/model/client";

import styled from "styled-components";
import { Modal } from "../../../../common/organism/modal";

import GoldLink from "src/presentation/common/atom/btn/gold_link";
import {
  ConstBorderRound,
  ConstBreakPoint,
  ConstColor,
} from "../../../../../config/styles_const/styles_const";
import BtnBorderSmall from "../../../../common/atom/btn/btn_border_small";
import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import HeadlineMiddle from "../../../../common/atom/text/headline_middle";
import Paragraph from "../../../../common/atom/text/paragraph";
import ProfileRightBtnWrapper from "../../../../common/atom/wrapper/profile_right_btn_wrapper";
import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import ClientClientsUpdateRoleForm from "./client_clients_update_role_form";
import MemberProfile from "./member_profile";

interface IProps {
  myClient?: Client;
  clients: Client[];
  clientsModalParams: { isVisible: boolean; clientId: string; client?: Client };
  handleUpdateRoleSubmit: (values: any) => void;
  handleClickDelete: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleClickModalOpen: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleClickModalClose: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const ClientClientsMainClients: React.FC<IProps> = (props) => {
  const {
    myClient,
    clients,
    clientsModalParams,
    handleUpdateRoleSubmit,
    handleClickDelete,
    handleClickModalOpen,
    handleClickModalClose,
  } = props;

  if (!myClient) {
    return null;
  }

  const modalClient: Client | undefined = clientsModalParams.client;
  const clientRole: Role = modalClient ? modalClient.role : Role.Role_Unknown;
  const clientId: string = modalClient ? modalClient.id : "";

  const initialValues = {
    role: clientRole,
    clientId,
  };

  let res: JSX.Element;

  // 通常ページ
  res = (
    <React.Fragment>
      <ProfileRightBtnWrapper>
        <AddLink to={"/client/clients/_create"}>新規追加</AddLink>
      </ProfileRightBtnWrapper>
      <Flex>
        <MemberProfile client={myClient} />
        {clients.map((client: Client) => {
          if (client.id === myClient.id) {
            return;
          }
          return (
            <MemberProfile
              key={client.id}
              client={client}
              handleClickModalOpen={
                myClient && myClient.role === Role.Role_Admin
                  ? handleClickModalOpen
                  : undefined
              }
            />
          );
        })}
      </Flex>
      <Modal
        isOpen={clientsModalParams.isVisible}
        onRequestClose={handleClickModalClose}
        contentLabel="Admin Delete Modal"
      >
        <Outer>
          <TimeButton onClick={handleClickModalClose} icon={"'\f00d'"} />
          <ModalTitleWrapper>
            <HeadlineMiddle>権限の変更</HeadlineMiddle>
          </ModalTitleWrapper>
          <ModalBodyWrapper>
            <Paragraph>以下の権限を選択して変更してください</Paragraph>
          </ModalBodyWrapper>
          <ClientClientsUpdateRoleForm
            initialValues={initialValues}
            onSubmit={handleUpdateRoleSubmit}
          />
          <ModalTitleWrapper>
            <HeadlineMiddle>メンバーの削除</HeadlineMiddle>
          </ModalTitleWrapper>
          <ModalBodyWrapper>
            <Paragraph>本当に削除してよろしいでしょうか</Paragraph>
            <Paragraph>
              問題がなければ以下の削除ボタンで削除を完了してください
            </Paragraph>
          </ModalBodyWrapper>
          <SubmitButtonWrapper>
            <BtnCorporateLarge
              type="button"
              widthSize="200px"
              value={clientId}
              onClick={handleClickDelete}
            >
              削除
            </BtnCorporateLarge>
          </SubmitButtonWrapper>
        </Outer>
      </Modal>
    </React.Fragment>
  );

  return res;
};

export default ClientClientsMainClients;

const Outer = styled.div`
  position: relative;
  padding: 40px 20px;
  width: 85vw;
  // border: 0.5px black solid;
  border-radius: ${ConstBorderRound.AuthBorder};
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.05);
  background-color: ${ConstColor.White};
  @media (min-width: ${ConstBreakPoint.Default}) {
    width: 375px;
  }
`;

const ModalTitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

const ModalBodyWrapper = styled.div`
  margin-bottom: 20px;
`;

const Flex = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    justify-content: space-between;

    &::after {
      content: "";
      display: block;
      width: 30%;
    }
  }
`;

const TimeButton = styled(BtnBorderSmall)`
  position: absolute;
  top: 20px;
  right: 20px;
  border: none;
  color: ${ConstColor.Base};
  padding: 0;
  &:before {
    margin-right: 0;
  }
`;

const AddLink = styled(GoldLink)`
  font-size: 12px;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/clients/info_clients/client_clients_main_clients.tsx